<template>
  <div>
    <h3 v-if="app_mode === 'advanced'" class="my-2">Checklist's</h3>
    <!-- TODO: Fazer rotina de adicionar checklist na OS -->
    <!-- <div class="box mb-3">
    <div class="add">
      ADICIONAR CHECKLIST
    </div>
  </div> -->
    <div v-if="checklists.length">
      <div class="checklist-itens">
        <div
          @click="openChecklist(item)"
          v-for="item in checklists"
          :key="item.id"
          v-bind:class="[item.checked_itens === item.total_itens ? 'reviewed' : '', 'checklist-item']"
        >
          <div class="icon">
            <div class="counter">
              <span v-if="item.checked_itens !== item.total_itens">{{ item.checked_itens }}/{{ item.total_itens }}</span>
              <v-icon color="white" v-else>mdi-check-bold</v-icon>
            </div>
          </div>
          <div class="text">
            <div class="title">
              {{ item.checklist.title }}
            </div>
            <div class="description">
              {{ item.checklist.description }}
            </div>
          </div>
          <div class="status">
            <div v-if="item.checked_itens === 0" class="status-info">
              <v-icon size="14px">mdi-clock</v-icon>
            </div>
            <div v-if="item.checked_itens_ok > 0" class="status-info ok">
              {{ item.checked_itens_ok }} <v-icon color="white" size="14px">mdi-check-circle</v-icon>
            </div>
            <div v-if="item.checked_itens_caution > 0" class="status-info caution">
              {{ item.checked_itens_caution }} <v-icon color="white" size="14px">mdi-alert</v-icon>
            </div>
            <div v-if="item.checked_itens_problem > 0" class="status-info problem">
              {{ item.checked_itens_problem }} <v-icon color="white" size="14px">mdi-close-octagon</v-icon>
            </div>
            <div v-if="item.checked_itens_not_applicable > 0" class="status-info not-applicable">
              {{ item.checked_itens_not_applicable }} <span>N/A</span>
            </div>
            <div v-if="item.checked_itens !== item.total_itens" class="status-text">Itens pendentes</div>
            <div v-if="item.checked_itens === item.total_itens" class="status-text">Todos os itens revisados</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <v-alert color="#48B38B" dark border="left"> Solicite ao suporte o cadastro do <b>checklist</b>. </v-alert>
    </div>
    <ChecklistDialog v-if="dialog_checklist.status" :dialog="dialog_checklist" @return="closeChecklistDialog" />
    <!-- <h3 class="my-2">Serviços</h3>
  <div v-if="false" class="box">
    <div class="add">
      <v-icon>mdi-plus</v-icon>
    </div>
  </div>
  <div v-else>
    <v-alert color="#48B38B" dark border="left">
      Este recurso estará disponível <b>em breve</b>.
    </v-alert>
  </div>
  <h3 class="my-2 mt-5">Peças / Produtos</h3>
  <div v-if="false" class="box">
    <div class="add">
      <v-icon>mdi-plus</v-icon>
    </div>
  </div>
  <div v-else>
    <v-alert color="#48B38B" dark border="left">
      Este recurso estará disponível <b>em breve</b>.
    </v-alert>
  </div> -->
    <!-- <div class="bottom-menu">
    <v-btn
      color="primary"
      class="pull-right"
      depressed
    >
      <v-icon>mdi-currency-usd</v-icon>
    </v-btn>
    <b>TOTAL:</b> R$ -- / <v-icon size="15" style="margin-top: -3px">mdi-clock</v-icon> -- min <br/>
    <small><b>PEÇAS:</b> R$ -- / <b>SERVIÇOS:</b> R$ --</small>
  </div> -->
  </div>
</template>

<script>
// TODO: ADICIONAR CHECKLIST;
import ChecklistDialog from './Dialogs/ChecklistDialog';

export default {
  name: 'Service',
  components: {
    ChecklistDialog
  },
  data: () => ({
    dialog_checklist: {
      status: false,
      checklist_id: null,
      service_order_id: null,
      isOperational: false,
    }
  }),
  computed: {
    service_order() {
      return this.$store.getters['ServiceOrder/intialDetails'];
    },
    checklists() {
      return this.$store.getters['ServiceOrder/checklists'];
    },
    app_mode() {
      return localStorage.getItem('app_mode') || 'advanced';
    }
  },
  methods: {
    closeChecklistDialog(payload) {
      this.dialog_checklist.status = false;
      this.$store.dispatch('ServiceOrder/updateChecklistItems', payload);
    },
    openChecklist(item) {
      this.dialog_checklist.service_order_id = this.service_order.id;
      this.dialog_checklist.checklist_id = item.checklist.id;
      this.dialog_checklist.checked_itens = item.checked_itens;
      this.dialog_checklist.checked_itens_ok = item.checked_itens_ok;
      this.dialog_checklist.checked_itens_caution = item.checked_itens_caution;
      this.dialog_checklist.checked_itens_problem = item.checked_itens_problem;
      this.dialog_checklist.checked_itens_not_applicable = item.checked_itens_not_applicable;
      this.dialog_checklist.status = true;
    }
  }
};
</script>

<style lang="scss">
.checklist-itens {
  .checklist-item {
    border: 1px solid silver;
    border-left: 5px solid silver;
    border-radius: 5px;
    padding: 10px 12px 5px 12px;
    overflow: hidden;
    margin-bottom: 10px;

    &.reviewed {
      border-color: #48b38b;

      .icon {
        background-color: #48b38b;
        color: #fff;
      }

      .status .status-text {
        color: #fff;
        background-color: #48b38b;
      }
    }

    .icon {
      float: left;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: #eee;
      text-align: center;
      line-height: 30px;
      margin-right: 10px;
      padding: 10px;

      .counter {
        font-weight: bold;
        font-size: 12px;
      }
    }

    .text {
      float: left;
      width: calc(100% - 60px);
      line-height: 20px;
      line-height: 18px;
    }

    .status {
      margin-top: 7px;
      padding-top: 5px;
      float: left;
      width: 100%;
      border-top: 1px solid #eee;
      font-size: 12px;

      .status-text {
        display: table;
        background-color: #eee;
        padding: 2px 8px;
        border-radius: 5px;
      }

      .status-info {
        display: table;
        float: right;
        background-color: #eee;
        padding: 2px 8px;
        border-radius: 5px;
        color: #fff;
        margin-left: 6px;

        &.ok {
          background-color: #48b38b;
        }

        &.caution {
          background-color: #ff8517;
        }

        &.problem {
          background-color: #f44336;
        }

        &.not-applicable {
          background-color: #2d3c47;

          span {
            color: white;
            font-weight: 600;
          }
        }
      }
    }
  }
}

.bottom-menu {
  padding: 12px 20px;
  background-color: #eeeeee;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  box-shadow: 0px 2px 4px -1px rgb(0 0 0), 0px 4px 5px 0px rgb(0 0 0), 0px 1px 10px 0px rgb(0 0 0 / 18%);
  border-top: 2px solid rgb(4, 150, 136);

  .pull-right {
    float: right;
    height: 48px !important;
  }
}
</style>
